'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPosition = getPosition;

var _types = require('./types');

function getPosition(level, column, index, position) {
  return {
    type: _types.GET_POSITION,
    level: level,
    column: column,
    index: index,
    position: position
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/actions.js
// module id = 1169
// module chunks = 0